import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-white">
      <div className="section-container">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="section-title">焦点专题</h2>
          <p className="section-subtitle">深度策划专题内容，换个姿势吃瓜</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group relative rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                <span className="inline-block text-xs font-semibold bg-accent-500 text-white px-3 py-1 rounded-full mb-2 md:mb-3">
                  {item.tag}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-white leading-snug group-hover:text-accent-300 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-white/80 mt-1 md:mt-2 line-clamp-2 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}